import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  margin-top: 10px;
`;
